import { setAccessToken } from '../dal/api-config'
import { captureException } from './sentry'

interface CredentialGetter {
  getCredentials: () => Promise<{
    accessToken: string | null
    idToken: string | null
  }>
}

export function createAccessTokenGetter({ getCredentials }: CredentialGetter) {
  return () =>
    getCredentials()
      .then((credentials) => {
        const accessToken = credentials.accessToken ?? null
        setAccessToken(accessToken)
        return accessToken
      })
      .catch((error) => {
        console.error('Error getting access token', error)
        captureException(error, {
          feature: 'auth',
          tags: { flow: 'get_token' },
        })
        setAccessToken(null)
        return null
      })
}
